









import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    downLoad(item:any){
        utils.myDownload({fileName: item.name, url: item.url})
    }
}
